import { useState } from 'react';
import { clsx } from 'clsx';
import { NavLink, NavLinkProps } from 'react-router-dom';
import { HomeIcon } from '@heroicons/react/solid';
import { components } from '@mosey/api-types';
import { StateSealCropped } from '../state-seals/StateSealCropped';
import { TaskCardStatus } from './types';

type Region = components['schemas']['Region'];

interface LocationCardProps {
  region: Region;
  selected?: boolean;
  status?:
    | 'home'
    | Extract<
        TaskCardStatus,
        'setup-collection' | 'question-collection' | 'overdue'
      >;
}

export const LocationCard = ({
  selected = false,
  region,
  status,
  ...props
}: LocationCardProps & Omit<NavLinkProps, 'className' | 'chilren'>) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <NavLink
      {...props}
      className={clsx(
        'group flex shrink-0 grow items-center gap-x-2 rounded border py-2 pl-2 pr-3 text-sm font-medium outline-none hover:border-teal-500 hover:bg-teal-400 hover:text-black focus-visible:ring-2 focus-visible:ring-teal-800',
        selected
          ? 'border-teal-700 bg-teal-700 text-teal-50'
          : 'border-teal-350 bg-teal-300 text-zinc-800',
      )}
      onMouseEnter={(event) => {
        setIsHovered(true);

        if (props.onMouseEnter) {
          props.onMouseEnter(event);
        }
      }}
      onMouseLeave={(event) => {
        setIsHovered(false);

        if (props.onMouseLeave) {
          props.onMouseLeave(event);
        }
      }}
    >
      <div className="size-6 shrink-0">
        <StateSealCropped
          opacity={1}
          tinted={!(selected || isHovered)}
          code={region.code}
        />
      </div>

      <div className="shrink-0 grow text-nowrap">{region.name}</div>

      {/* TODO: Add additional status icons */}
      {status === 'home' && (
        <HomeIcon
          className={clsx(
            'size-3',
            selected
              ? 'text-teal-50 group-hover:text-teal-800'
              : 'text-teal-800',
          )}
          aria-label="Incorporation State"
        />
      )}
    </NavLink>
  );
};
